import { defineComponent as _defineComponent } from 'vue';
import { BPopover } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateSummaryPopover',
    props: {
        target: null,
        template: null
    },
    setup(__props) {
        const props = __props;
        const popoverPlacement = "rightbottom";
        return { __sfc: true, props, popoverPlacement, BPopover };
    }
});
